export const ORBIT_DECO_SIZE = 300;
export const ZODIAC_RING_R = 130;

const CENTER_SIZE = 50;

const WEDDING_BANDS = [
  { size: 62, borderWidth: 2, colorKey: "secondary", opacity: "88" },
  { size: 48, borderWidth: 1.5, colorKey: "tertiary", opacity: "77" },
];

function natalTracks(acc) {
  return [
    {
      r: 100,
      dur: 18,
      ringBorder: `1px solid ${acc.primary}33`,
      ringDir: "normal",
      planet: { color: acc.primary, size: 10, reverse: false },
    },
    {
      r: 72,
      dur: 12,
      ringBorder: `1px solid ${acc.tertiary}44`,
      ringDir: "reverse",
      planet: { color: acc.tertiary, size: 8, reverse: true },
    },
    {
      r: 48,
      dur: 8,
      ringBorder: `1px solid ${acc.primary}55`,
      ringDir: "normal",
      planet: { color: acc.primary, size: 6, reverse: false },
    },
  ];
}

function weddingTracks(acc) {
  return [
    {
      r: 125,
      dur: 20,
      ringBorder: `1px solid ${acc.secondary}55`,
      ringDir: "normal",
      planet: { color: acc.secondary, size: 11, glyph: "♡", reverse: false },
    },
    {
      r: 92,
      dur: 14,
      ringBorder: `1px solid ${acc.secondary}44`,
      ringDir: "reverse",
      planet: { color: acc.tertiary, size: 8, reverse: true },
    },
    {
      r: 58,
      dur: 10,
      ringBorder: `1px solid ${acc.secondary}22`,
      ringDir: "normal",
      planet: { color: acc.secondary, size: 6, reverse: false },
    },
  ];
}

export function tracksForVariant(variant, acc) {
  return variant === "wedding" ? weddingTracks(acc) : natalTracks(acc);
}

export function centerStyleForVariant(variant, acc) {
  if (variant === "wedding") {
    return {
      size: CENTER_SIZE,
      background: `radial-gradient(circle, ${acc.secondary}ee, ${acc.tertiary}88)`,
      boxShadow: `0 0 48px ${acc.secondary}bb, 0 0 24px ${acc.tertiary}66`,
      bands: WEDDING_BANDS.map(({ size, borderWidth, colorKey, opacity }) => ({
        size,
        border: `${borderWidth}px solid ${acc[colorKey]}${opacity}`,
      })),
    };
  }
  return {
    size: CENTER_SIZE,
    background: `radial-gradient(circle, ${acc.primary}cc, ${acc.tertiary}66)`,
    boxShadow: `0 0 40px ${acc.primary}99`,
    bands: null,
  };
}
